import { createReducer } from '@reduxjs/toolkit';

import { countries } from '../../constants';
import {
  addQuoteLine,
  changeCountrySplit,
  changeQuoteLine,
  changeQuoteLineGender,
  copyCountrySplit,
  duplicateQuoteLine,
  filterQuoteLines,
  removeQuoteLine,
  splitCountrySharesEqually,
  submit,
} from '../actions';
import { isLineFilteredOut } from '../utils/filter-utils';
import generateEqualShares from '../utils/generate-equal-shares';
import { getDefaultGenderShare } from '../utils/get-default-gender-shares';

export default createReducer(
  {},
  /* eslint-disable no-param-reassign */
  {
    [changeQuoteLine]: (state, { payload, meta }) => {
      const quoteLine = state[meta.quoteLineId];
      quoteLine[payload.name] = payload.value;
    },
    [changeQuoteLineGender]: (state, { payload, meta }) => {
      const quoteLine = state[meta.quoteLineId];
      const { genders } = payload;
      state[meta.quoteLineId] = {
        ...quoteLine,
        genders,
        ...getDefaultGenderShare(meta.product, genders),
      };
    },
    [changeCountrySplit]: (state, { payload, meta }) => {
      const quoteLine = state[meta.quoteLineId];
      const value = payload.value || 0;
      quoteLine.countrySplit[payload.countryCode] = value;
    },
    [splitCountrySharesEqually]: (state, { payload }) => {
      state[payload.quoteLineId].countrySplit = generateEqualShares(countries);
    },
    [copyCountrySplit]: (state, { payload }) => {
      payload.targetQuoteLineIds.forEach(targetId => {
        const targetQuoteLine = state[targetId];
        targetQuoteLine.countrySplit = payload.sourceCountrySplit;
      });
    },
    [addQuoteLine]: (state, { payload }) => {
      state[payload.id] = payload;
    },
    [removeQuoteLine]: (state, { meta }) => {
      delete state[meta.quoteLineId];
    },
    [duplicateQuoteLine]: (
      state,
      { payload: { id }, meta: { quoteLineId } },
    ) => {
      state[id] = { ...state[quoteLineId], id };
    },
    [`${submit}-success`]: (state, { payload }) => payload.quoteLinesById,
    [filterQuoteLines]: (state, { payload: { selectedFilters } }) => {
      Object.values(state).forEach(line => {
        line.filteredOut = isLineFilteredOut(line, selectedFilters);
      });
    },
  },
  /* eslint-enable no-param-reassign */
);
